import { api_get, stringfy_post, api_post } from '../utils/http'

const PREFIX = '/csearch/api'

// 查询
async function queryProperNoun(options: any) {
  const res = await api_post(`${PREFIX}/ext_words/query`, options)
  const { success, data } = res
  let list: any[] = []
  let total: number = 0
  if (success) {
    list = data.map((item, index) => {
      return {
        key: index + 1 + 20 * (options.page - 1),
        ...item
      }
    })
    total = res.total
  }
  return { list, total }
}

// 改变专有词状态
async function changeStatus(options: any) {
  const res = await stringfy_post(`${PREFIX}/ext_words/online`, options)
  return res
}

// 创建/编辑专有词分类
async function editCategory(options: any) {
  const res = await api_post(`${PREFIX}/ext_words/edit-category`, options)
  return res
}

// 查询分类
async function queryCategory(options: any) {
  const res = await api_post(`${PREFIX}/ext_words/query-category`, options)
  return res
}

// 创建/编辑专有词
async function editProperNoun(options: any) {
  const res = await api_post(`${PREFIX}/ext_words/edit-ext-word`, options)
  return res
}

// 删除专有词
async function removeProperNoun(options: any) {
  const res = await stringfy_post(`${PREFIX}/ext_words/delete`, options)
  return res
}

// 重建索引
async function reindex(options: any) {
  const res = await api_post(`${PREFIX}/ext_words/reindex`, options)
  return res
}

export {
  queryProperNoun,
  changeStatus,
  editCategory,
  queryCategory,
  editProperNoun,
  removeProperNoun,
  reindex
}
